
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb76a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb76a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $e9d842817973204b$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["cZK9K","index.d5c45465.js","c8l1C","mobile-image-hero-1.0adf4be4.jpg","8Q6rW","desktop-image-hero-1.495b33c1.jpg","d1oyI","mobile-image-hero-2.4bb1e4e7.jpg","kUpZs","desktop-image-hero-2.524b2452.jpg","2iQoJ","mobile-image-hero-3.a1322951.jpg","28MaG","desktop-image-hero-3.9603d773.jpg"]'));

var $e1fa55b338067e8b$exports = {};
$e1fa55b338067e8b$exports = JSON.parse('[{"heading":"Discover innovative ways to decorate","content":"We provide unmatched quality, comfort, and style for property owners across the country. Our experts combine form and function in bringing your vision to life. Create a room in your own style with our collection and make your property a reflection of you and what you love."},{"heading":"We are available all across the globe","content":"With stores all over the world, it\'s easy for you to find furniture for your home or place of business. Locally, we\u2019re in most major cities throughout the country. Find the branch nearest you using our store locator. Any questions? Don\'t hesitate to contact us today."},{"heading":"Manufactured with the best materials","content":"Our modern furniture store provide a high level of quality. Our company has invested in advanced technology to ensure that every product is made as perfect and as consistent as possible. With three decades of experience in this industry, we understand what customers want for their home and office."}]');


var $b96dc4e760191d45$exports = {};
$b96dc4e760191d45$exports = new URL("mobile-image-hero-1.0adf4be4.jpg", import.meta.url).toString();


var $2d29de2df5a4b05f$exports = {};
$2d29de2df5a4b05f$exports = new URL("desktop-image-hero-1.495b33c1.jpg", import.meta.url).toString();


var $53e93e17f754bc96$exports = {};
$53e93e17f754bc96$exports = new URL("mobile-image-hero-2.4bb1e4e7.jpg", import.meta.url).toString();


var $f4a5d1a2768f9eb1$exports = {};
$f4a5d1a2768f9eb1$exports = new URL("desktop-image-hero-2.524b2452.jpg", import.meta.url).toString();


var $1d3ad6fcd8fb306c$exports = {};
$1d3ad6fcd8fb306c$exports = new URL("mobile-image-hero-3.a1322951.jpg", import.meta.url).toString();


var $1cc26b438629e110$exports = {};
$1cc26b438629e110$exports = new URL("desktop-image-hero-3.9603d773.jpg", import.meta.url).toString();


function $ff4ff9fb7c8d8701$export$2e2bcd8739ae039(sliderItems) {
    const items = new Set(sliderItems || []); /* Represent slider items as a set */ 
    let cursor = 0;
    let isLargeViewport = window.innerWidth >= 768;
    // Bind main slider
    const heroEl = document.querySelector("#hero-slider");
    // Bind next/prev buttons
    const nextBtn = document.querySelector("#slider-next");
    const prevBtn = document.querySelector("#slider-prev");
    const itemArr = Array.from(items);
    // Setup listeners
    $ff4ff9fb7c8d8701$var$bindHandler(nextBtn, ()=>{
        cursor = cursor >= items.size - 1 ? 0 : ++cursor;
        $ff4ff9fb7c8d8701$var$applyContent(heroEl, itemArr, cursor, isLargeViewport);
    });
    $ff4ff9fb7c8d8701$var$bindHandler(prevBtn, ()=>{
        cursor = cursor <= 0 ? items.size - 1 : --cursor;
        $ff4ff9fb7c8d8701$var$applyContent(heroEl, itemArr, cursor, isLargeViewport);
    });
    window.addEventListener("resize", ()=>{
        isLargeViewport = window.innerWidth >= 768;
        $ff4ff9fb7c8d8701$var$applyContent(heroEl, itemArr, cursor, isLargeViewport);
    });
    // Execute initial content
    $ff4ff9fb7c8d8701$var$applyContent(heroEl, itemArr, cursor, isLargeViewport);
}
function $ff4ff9fb7c8d8701$var$bindHandler(node, handler) {
    window.addEventListener("keydown", ({ code: code })=>{
        if (code === "ArrowLeft" || code === "ArrowRight") handler();
    });
    node.addEventListener("click", handler);
}
function $ff4ff9fb7c8d8701$var$applyContent(to, content, selected, isLargeViewport) {
    if (!Array.isArray(content)) throw new Error("Invalid structure: Not an array");
    let imgUrl;
    switch(selected){
        case 0:
            imgUrl = `url(${!isLargeViewport ? (0, (/*@__PURE__*/$parcel$interopDefault($b96dc4e760191d45$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($2d29de2df5a4b05f$exports)))})`;
            break;
        case 1:
            imgUrl = `url(${!isLargeViewport ? (0, (/*@__PURE__*/$parcel$interopDefault($53e93e17f754bc96$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($f4a5d1a2768f9eb1$exports)))})`;
            break;
        case 2:
            imgUrl = `url(${!isLargeViewport ? (0, (/*@__PURE__*/$parcel$interopDefault($1d3ad6fcd8fb306c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($1cc26b438629e110$exports)))})`;
            break;
    }
    to.style.backgroundImage = imgUrl;
    const headingEl = document.querySelector("#slider-heading");
    const contentEl = document.querySelector("#slider-content");
    headingEl.innerText = content[selected].heading;
    contentEl.innerText = content[selected].content;
}


document.addEventListener("DOMContentLoaded", (0, $ff4ff9fb7c8d8701$export$2e2bcd8739ae039)($e1fa55b338067e8b$exports));


//# sourceMappingURL=index.d5c45465.js.map
